export default {
    APP_VERSION: "1.0.1",
    APP_NAME: "yodatask-web-ui",
    API_URL: process.env.VUE_APP_DEV_API_URL
  };
  